import { render, staticRenderFns } from "./EditorTextSizePicker.vue?vue&type=template&id=42635e3a"
import script from "./EditorTextSizePicker.vue?vue&type=script&lang=js"
export * from "./EditorTextSizePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports